import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { Button, Container } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { customerStoreCreditHistory } from '../../store/actions/customerAction'
import { GET_CUSTOMER_STORE_CREDIT_HISTORY } from '../../store/types'
import Layout from '../../components/Layout'
import moment from 'moment'

const HistoryList = ({ history }) => {
    return (
        <TableRow>
            <TableCell>{history?.type}</TableCell>
            <TableCell>
                {history?.type === 'ORDER_PAYMENT' && '-'}${history?.amount}
            </TableCell>
            <TableCell>{moment(history?.date).format('ll')}</TableCell>
        </TableRow>
    )
}

const StoreCreditHistory = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { id } = useParams()

    const [historyLength, setHistoryLength] = useState(3)

    const { storeCreditHistory } = useSelector((state) => state.customer)
    useEffect(() => {
        dispatch(customerStoreCreditHistory(id, historyLength))
        return () => {
            dispatch({
                type: GET_CUSTOMER_STORE_CREDIT_HISTORY,
                payload: null,
            })
        }
    }, [dispatch, id, historyLength])
    return (
        <Layout>
            <Container>
                <Button
                    style={{ marginBottom: '20px' }}
                    onClick={() => navigate('/customers')}
                >
                    Back
                </Button>
                <div>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                            Date Range
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={historyLength}
                            label="Date Month Range"
                            onChange={(event) =>
                                setHistoryLength(event.target.value)
                            }
                        >
                            <MenuItem value={3}>3 Months</MenuItem>
                            <MenuItem value={6}>6 Months</MenuItem>
                            <MenuItem value={9}>9 Months</MenuItem>
                            <MenuItem value={12}>12 Months</MenuItem>
                            {/* <MenuItem value={36}>36 Months</MenuItem> */}
                        </Select>
                    </FormControl>
                </div>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Type</TableCell>
                                <TableCell>Amount</TableCell>
                                <TableCell>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {storeCreditHistory?.map((history) => (
                                <HistoryList
                                    history={history}
                                    key={history.id}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Container>
        </Layout>
    )
}

export default StoreCreditHistory
